import { AuthInterceptor } from "./core/core.authInterceptor";
import { UserManager, User } from "oidc-client";
import * as angular from "angular";

import dashboardModule from "./dashboard/dashboard.module";
import { configRoute } from "./app.config";

import coreModule from "./core/core.module";
import commonModule from "./common/app.common";

import manageServicesModule from "./manage/manage.module";
import changePasswordModule from "./change-password/change-password.module";
import logsModule from "./logs/logs.module";
import bengLogsModule from "./beng-logs/beng-logs.module";
import usersModule from "./users/users.module";
import schedulerModule from "./scheduler/scheduler.module";
import backupAndRestoreModule from "./backup-and-restore/backup-and-restore.module";
import instanceSettingsModule from "./instance-settings/instance-settings.module";
import sharedStorageModule from "./shared-storage/shared-storage.module";
import dataDirectModule from "./data-direct/data-direct.module";
import capsuleModule from "./capsule/capsule.module";

import { IHttpProvider } from "angular";
import { configTheme, configIcons } from "./app-theme.config";
import { configureAppShell } from "./app-shell.route";
import hierarchyModalModule from "./hierarchy-modal/hierarchyModal.module";
import hierarchySideNavModule from "./hierarchy-nav/hierarchySideNav.module";
import hierarchyModule from "./hierarchy-grid/hierarchy.module";
import capsuleManagerGuideModule from "./capsule-manager-guide/capsuleManagerGuide.module";

export const buildAuthorizedAppModule = (adminUserManager: UserManager, adminUser: User, webUserManager: UserManager, boardWebEndpoint: string, user: User, idpEndpoint: string) => {
    coreModule.constant("BoardWebAdminUserManager", adminUserManager);
    coreModule.constant("BoardWebUserManager", webUserManager);
    coreModule.constant("WEB_ENDPOINT", boardWebEndpoint);
    coreModule.constant("BoardWebAdminUser", adminUser);
    coreModule.constant("BoardWebUser", user);
    coreModule.constant("IDP_ENDPOINT", idpEndpoint);
    coreModule.constant('USERNAME_CLAIM_TYPE', idpEndpoint ? 'name' : 'preferred_username');

    return angular
        .module("board.web.admin", [
            coreModule.name,
            commonModule,
            dashboardModule,
            manageServicesModule,
            logsModule,
            bengLogsModule,
            usersModule,
            schedulerModule,
            hierarchyModalModule,
            hierarchySideNavModule,
            capsuleManagerGuideModule,
            hierarchyModule,
            backupAndRestoreModule,
            changePasswordModule,
            instanceSettingsModule,
            sharedStorageModule,
            dataDirectModule,
            capsuleModule
        ])
        .config(["$httpProvider", ($httpProvider: IHttpProvider) => {
            $httpProvider.interceptors.push(AuthInterceptor.factory());
        }])
        .config(configureAppShell)
        .config(configRoute)
        .config(configTheme)
        .config(configIcons)
        .name;
};



// WEBPACK FOOTER //
// ./app/authorized-app.module.ts